import { type FC, useMemo } from "react";
import { Resources } from "web_myplann/Infrastructure/Translations/Resources";
import { InspirationColdIntro } from "web_myplann/Inspiration/Components/InspirationColdIntro";
import { InspirationExampleText } from "web_myplann/Inspiration/Components/InspirationExampleText";
import { useInspirationMoney } from "web_myplann/Inspiration/Hooks/useInspirationMoney";
import { RetirementExampleBreakdown } from "web_myplann/Inspiration/Retirement/Components/RetirementExampleBreakdown";
import { getRetirementExample } from "web_myplann/Inspiration/Retirement/Utils/getRetirementExample";

const R = Resources.Inspiration.Retirement;

export const RetirementColdIntro: FC = () => {
	const example = useMemo(getRetirementExample, []);
	const money = useInspirationMoney();

	return (
		<InspirationColdIntro
			intro={R.intro}
			exampleTitle={R.exampleTitle}
			exampleHint={R.exampleHint}
		>
			<InspirationExampleText text={R.exampleBody} relaxed />

			<RetirementExampleBreakdown
				expenses={example.expenses}
				mortgage={example.mortgage}
				mortgageEndYear={example.mortgageEndYear}
				savings={example.savings}
				remaining={example.remaining}
			/>

			<InspirationExampleText
				text={R.exampleOutcome}
				relaxed
				values={{
					state: money(example.statePension),
					gap: money(example.gap),
					capital: money(example.capital),
				}}
			/>
		</InspirationColdIntro>
	);
};
